import { CSSEditorAction, CSSEditorHeader, CSSEditorLabel, CSSEditorMenuButton } from './style';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';
import { WidgetEditor } from 'jamespot-front-business';
import { useAppDispatch, useAppSelector } from '../../redux/store';

const JRCButton = commonComponentsRegistry.getLazyComponent('Button');
const JRCIcon = commonComponentsRegistry.getLazyComponent('Icon');

/*
    Editor popup (center part)
*/
export const EditorPopup = ({ uniqid }: { uniqid: string }) => {
    const dispatch = useAppDispatch();
    const editor = useAppSelector((state) => WidgetEditor.selectors.selectEditor(state, uniqid));

    const onClick = () => {
        dispatch(WidgetEditor.slice.actions.flushEditorPopup({ uniqid }));
    };

    const onSave = () => {
        dispatch(WidgetEditor.slice.actions.flushEditorPopup({ uniqid }));
    };

    if (editor && editor.popup && editor.view) {
        return (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: 'white', marginTop: 90 }}>
                <CSSEditorHeader>
                    <CSSEditorAction />
                    <CSSEditorLabel>Popup</CSSEditorLabel>
                    <CSSEditorAction>
                        <CSSEditorMenuButton onClick={onClick}>
                            <JRCIcon name="icon-times" color="grey2" size={26.75} />
                        </CSSEditorMenuButton>
                    </CSSEditorAction>
                </CSSEditorHeader>
                <div style={{ flex: 1, display: 'flex' }}>{editor.view}</div>
                <CSSEditorHeader>
                    <JRCButton onClick={onSave}>Save</JRCButton>
                </CSSEditorHeader>
            </div>
        );
    }

    return <></>;
};
